/** News */

'use strict'

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

$(document).ready(function () {
  // Featured News Carousel - Slick Initialization
  if ($(".featured-news__carousel")[0]) {  // Check if this page have this class
    let featuredNewsCarouselNav = $('.featured-news__counter');
    let featuredNewsCarousel = $('.featured-news__carousel');

    featuredNewsCarousel.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      // If currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      let currentSlideNumber = (currentSlide ? currentSlide : 0) + 1;

      // Update current active slide number of navigation
      featuredNewsCarouselNav.html(currentSlideNumber + '/' + '<span>' + slick.slideCount + '</span>');
    });

    featuredNewsCarousel.slick({
      centerMode: false,
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $('.slick__prev--featured-news'),
      nextArrow: $('.slick__next--featured-news')
    });
  }

  // Other Featured News Carousel - Slick Initialization
  if ($(".fnews-other__carousel")[0]) {  // Check if this page have this class
    var featuredNewsCarouselNavOther = $('.fnews-other__counter');
    var featuredNewsCarouselOther = $('.fnews-other__carousel');

    featuredNewsCarouselOther.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      // If currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      let currentSlideNumber = (currentSlide ? currentSlide : 0) + 1;

      // Update current active slide number of navigation
      featuredNewsCarouselNavOther.html(currentSlideNumber + '/' + '<span>' + slick.slideCount + '</span>');
    });

    featuredNewsCarouselOther.slick({
      centerMode: false,
      dots: false,
      arrows: true,
      infinite: false,
      swipe: false,
      draggable: false,
      swipeToSlide: false,
      touchMove: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $('.slick__prev--fnews-other'),
      nextArrow: $('.slick__next--fnews-other')
    });
  }

  // Load More Button Event
  $('.js-btn-load-more').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($(this).hasClass('js-btn-load-more--loading')) {
      $(this).html("Load More");
      $(this).removeClass('js-btn-load-more--loading');
      $(this).removeClass("load");
    } else {
      $(this).addClass('js-btn-load-more--loading');
      $(this).html("Loading... <span class='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>");
      $(this).addClass("load");
    }
  });


  // Trigger mobile nav tabs
  $('.js-custom-select .js-custom-select-dropdown .custom-select__items').each(function (_, el) {
    let tabTarget = $(el).data('tab')
    if (!tabTarget) return

    const triggerEl = document.querySelector(`#news-tab *[data-bs-target="${tabTarget}"]`)
    const tabTrigger = new bootstrap.Tab(triggerEl)

    $(el).on('click', function () {
      tabTrigger.show()
    })
  })
});